import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { selectCatalogingOnSiteEnabled } from '../../../catalog/selectors/CatalogSelectors';
import { contentCountsRequest } from '../../actions/spaces/ContentCountsActions';
import { selectContentCounts, selectContentCountsUpToDate } from '../../selectors/ContentCountsSelector';
import { CompositeSessionInfoSelectors } from '../../selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { selectSpaceInfo } from '../../selectors/SpaceInfoSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { WorkbookSpace, WorkbookSpaceDispatchProps, WorkbookSpaceStateProps } from './WorkbookSpace';
import { getDraftInfoForHeaderBanner } from '../../../drafts/utils/DraftUtils';


const mapStateToProps: MapStateToProps<WorkbookSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
  urls: siteUrlsSelector(state),
  catalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state),
  contentCounts: selectContentCounts<'workbook'>(state, 'workbook'),
  contentCountsUptoDate: selectContentCountsUpToDate(state),
  areUsersVisible: !CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state),
  draft: state.drafts?.drafts && getDraftInfoForHeaderBanner(state.drafts),
});

const mapDispatchToProps: MapDispatchToProps<WorkbookSpaceDispatchProps> =
  (dispatch) => bindActionCreators({
    fetchUpdatedContentCounts: contentCountsRequest
  },
  dispatch);

export const ConnectedWorkbookSpace = connect(mapStateToProps, mapDispatchToProps)(WorkbookSpace);
